import { route } from '../../../../constants.ts';

/// LAYER ACTIONS
export const UPDATE_LAYER_TILING_LATTICE_ID = `${route}/UPDATE_LAYER_TILING_LATTICE_ID`;
export const UPDATE_LAYER_ENABLED = `${route}/UPDATE_LAYER_ENABLED`;
export const UPDATE_LAYER_SELECTION = `${route}/UPDATE_LAYER_SELECTION`;
export const UPDATE_LAYER_SCALE = `${route}/UPDATE_LAYER_SCALE`;
export const UPDATE_LAYER_ROTATION = `${route}/UPDATE_LAYER_ROTATION`;
export const UPDATE_LAYER_PARAM = `${route}/UPDATE_LAYER_PARAM`;
export const UPDATE_LAYER_FIXED_RATIO = `${route}/UPDATE_LAYER_FIXED_RATIO`;

export function updateLayerTilingLatticeId({ layerIndex = 0, tilingLatticeId, transient = false }) {
    return {
        type: UPDATE_LAYER_TILING_LATTICE_ID,
        payload: { layerIndex, tilingLatticeId, transient },
    };
}

export function updateLayerEnabled({ layerIndex, enabled }) {
    return {
        type: UPDATE_LAYER_ENABLED,
        payload: { layerIndex, enabled },
    };
}

export function updateLayerSelection({ layerIndex, type, selection, transient = false }) {
    return {
        type: UPDATE_LAYER_SELECTION,
        payload: { layerIndex, type, selection, transient },
    };
}

export function updateLayerScale({ layerIndex, value, transient = true }) {
    return {
        type: UPDATE_LAYER_SCALE,
        payload: { layerIndex, value, transient },
    };
}

export function updateLayerRotation({ layerIndex, value, transient = true }) {
    return {
        type: UPDATE_LAYER_ROTATION,
        payload: { layerIndex, value, transient },
    };
}

export function updateLayerParam({ layerIndex, value, path, transient = true }) {
    return {
        type: UPDATE_LAYER_PARAM,
        payload: { layerIndex, value, path, transient },
    };
}

export function updateLayerFixedRatio({ layerIndex, value, transient = true }) {
    return {
        type: UPDATE_LAYER_FIXED_RATIO,
        payload: { layerIndex, value, transient },
    };
}
